export default __webpack_public_path__ + "static/media/info-icon.26f6e254.svg";